export default "__VITE_ASSET__52de1708__"